this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
const cartDrawer = document.querySelector('cart-drawer.drawer');

function updateCartDrawerProgressBar() {
  /* Progress Bar - Cart Drawer */
  const cartAlert = document.querySelector('.cart-alert');
  if(cartAlert) {
    const goalValue = document.querySelector('.cart-alert').getAttribute("metafield-goal-value");
    let cartSubtotalValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value").getAttribute('value');
    let goalRemainingValue = goalValue - cartSubtotalValue;
    goalRemainingValue = Number(goalRemainingValue).toFixed(2);

    if(goalRemainingValue > 0) {
      document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
      document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue}`;
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue);
      document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$8'
    } else {
      document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue);
      document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$0'
    }

    window.Klarna.OnsiteMessaging.refresh();
    
    let cartDrawerWishlist = document.querySelectorAll('#CartDrawer .quick-add-wishlist');
    cartDrawerWishlist.forEach(function(item) {
      item.remove();
    });
    const scrollbarVisible = (element) => {
      return element.scrollHeight > element.clientHeight;
    }
    const cartDrawerContainer = document.querySelector('cart-drawer-items')
        
    if(scrollbarVisible(cartDrawerContainer) === true) {
      document.querySelector('.cart-drawer .drawer__cart-items-wrapper').style.marginRight = '1rem';
      document.querySelector('.cart-drawer .cart-alert').style.marginRight = '1rem';
      document.querySelector('.cart-drawer .slider-button--next').style.marginRight = '1rem';
    }
  }
}

const removeAndAddProtection = async (remove, add) => {
  const removeRequest = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: String(remove),
      quantity: 0,
      sections: this.cart.getSectionsToRender().map((section) => section.section),
    }),
  };

  const addRequest = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: String(add),
      quantity: 1,
      sections: this.cart.getSectionsToRender().map((section) => section.section),
    }),
  };

  await fetch(`${routes.cart_change_url}`, removeRequest)
    .then((res) => res.json())
    .then(() => {
      fetch('/cart/add.js', addRequest)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            sessionStorage.setItem('le_ship_protection_opted_out', false);
            sessionStorage.setItem('le_ship_protection_variant', shippingProtectionVariantId);
            document.getElementById('cartShippingProtection').checked = true;

            document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
              determineShippingProtection();
            });

            this.cart.getSectionsToRender().forEach((section => {
              const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML =
              this.getSectionInnerHTML(data.sections[section.section], section.selector);
            }));

            /* Progress Bar - Cart Drawer */
            updateCartDrawerProgressBar();
          }
          fetch('/cart.js')
          .then((response) => response.json())
          .then((responseText) => {
            this.updateCartCrossSells(responseText.items);
            document.getElementById('cartShippingProtection').checked = true;
            sessionStorage.setItem('le_ship_protection_opted_out', false);
            sessionStorage.setItem('le_ship_protection_variant', shippingProtectionVariantId);

            document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
              determineShippingProtection();
            });
            
            document.querySelectorAll('.product').forEach((product => {
              if(product.getAttribute('data-product-id') == add) {
                add = product.querySelector('.product__quantity span').innerHTML.trim();
              }
            }));
          });
        });
    });
};

function addShippingProtection(shippingProtectionVariantId) {
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  formData.append('id', String(shippingProtectionVariantId));
  formData.append('quantity', '1');
  formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
  formData.append('sections_url', window.location.pathname);

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {

    sessionStorage.setItem('le_ship_protection_opted_out', false);
    sessionStorage.setItem('le_ship_protection_variant', shippingProtectionVariantId);

    this.cart.getSectionsToRender().forEach((section => {
    const elementToReplace =
    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    elementToReplace.innerHTML =
    this.getSectionInnerHTML(response.sections[section.section], section.selector);
    }));

    fetch('/cart.js')
    .then((response) => response.json())
    .then((responseText) => {

      document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
        determineShippingProtection();
      });

      document.getElementById('cartShippingProtection').checked = true;
      document.querySelector('.drawer__inner').setAttribute('value', responseText.item_count);
      updateCartDrawerProgressBar();
      cartDrawer.classList.toggle('is-empty', responseText.item_count === 0);
    })

  })
  .catch((e) => {
    console.error(e);
  })
}

function removeShippingProtection() {
  let cartItems = document.querySelectorAll('#CartDrawer .cart-items tr');
  cartItems.forEach(function(item) {
    if (item.getAttribute('data-product-id') === '7250028822704') {
      return shippingProtectionVariantInCart = item.getAttribute('data-variant-id');
    }
  });
  fetch('/cart.js')
  .then((response) => response.json())
  .then((responseText) => {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('id', String(shippingProtectionVariantInCart));
      formData.append('quantity', '0');
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {

        this.cart.getSectionsToRender().forEach((section => {
        const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML =
        this.getSectionInnerHTML(response.sections[section.section], section.selector);
        }));

        fetch('/cart.js')
        .then((response) => response.json())
        .then((responseText) => {
          // document.getElementById('cartShippingProtection').checked = false;

          // document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
          //   determineShippingProtection();
          // });

          document.querySelector('.drawer__inner').setAttribute('value', responseText.item_count);
          updateCartDrawerProgressBar();
          cartDrawer.classList.toggle('is-empty', responseText.item_count === 0);
        })

        // sessionStorage.setItem('le_ship_protection_opted_out', true);
        // sessionStorage.setItem('le_ship_protection_variant', '');

      })
      .catch((e) => {
        console.error(e);
      })
  });
}

function removeDuplicateShippingProtection(shippingProtectionVariantId) {
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  formData.append('id', String(shippingProtectionVariantId));
  formData.append('quantity', '1');
  formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
  formData.append('sections_url', window.location.pathname);

  config.body = formData;

  fetch(`${routes.cart_change_url}`, config)
  .then((response) => response.json())
  .then((response) => {

    this.cart.getSectionsToRender().forEach((section => {
    const elementToReplace =
    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    elementToReplace.innerHTML =
    this.getSectionInnerHTML(response.sections[section.section], section.selector);

    /* Progress Bar - Cart Drawer */
    updateCartDrawerProgressBar();
    document.getElementById('cartShippingProtection').checked = true;

  }));
  })
  .catch((e) => {
    console.error(e);
  })
}

const removeAndRemoveAndAddProtection = async (remove, add) => {
  const removeRequest1 = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: String(remove[0]),
      quantity: 0,
      sections: this.cart.getSectionsToRender().map((section) => section.section),
    }),
  };

  const removeRequest2 = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: String(remove[1]),
      quantity: 0,
      sections: this.cart.getSectionsToRender().map((section) => section.section),
    }),
  };

  const addRequest = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: String(add),
      quantity: 1,
      sections: this.cart.getSectionsToRender().map((section) => section.section),
    }),
  };

  await fetch(`${routes.cart_change_url}`, removeRequest1)
    .then((res) => res.json())
    .then(() => {
      fetch(`${routes.cart_change_url}`, removeRequest2)
      .then((res) => res.json())
      .then(() => {
        fetch('/cart/add.js', addRequest)
          .then((res) => res.json())
          .then((data) => {
            if (data.id) {
              sessionStorage.setItem('le_ship_protection_opted_out', false);
              sessionStorage.setItem('le_ship_protection_variant', shippingProtectionVariantId);
              document.getElementById('cartShippingProtection').checked = true;

              document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
                determineShippingProtection();
              });

              this.cart.getSectionsToRender().forEach((section => {
                const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML =
                this.getSectionInnerHTML(data.sections[section.section], section.selector);
              }));

              /* Progress Bar - Cart Drawer */
              updateCartDrawerProgressBar();
            }
            fetch('/cart.js')
            .then((response) => response.json())
            .then((responseText) => {
              this.updateCartCrossSells(responseText.items);
              document.getElementById('cartShippingProtection').checked = true;
              sessionStorage.setItem('le_ship_protection_opted_out', false);
              sessionStorage.setItem('le_ship_protection_variant', shippingProtectionVariantId);

              document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
                determineShippingProtection();
              });
              
              document.querySelectorAll('.product').forEach((product => {
                if(product.getAttribute('data-product-id') == add) {
                  add = product.querySelector('.product__quantity span').innerHTML.trim();
                }
              }));
            });
          });
      });
    });
};

function getSectionInnerHTML(html, selector = '.shopify-section') {
  return new DOMParser()
  .parseFromString(html, 'text/html')
  .querySelector(selector).innerHTML;
}

let shippingProtectionVariantId = '';
let shippingProtectionCost = '';
let checkoutSubtotal = 0;
let shippingProtectionQuantity = 0;
let productPrice = 0;
let productQuantity = 0;
let shippingProtectionInCart = '';

function determineShippingProtection() {
  fetch(`${shopUrl}` + '/products/' + shippingProtectionProduct + '.js')
  .then((response) => response.json())
  .then((responseText) => {

    const shippingProtectionProductId = responseText.id;
    
    document.querySelectorAll('.cart-item').forEach((product => {
      if(product.querySelector('.cart-item__name').innerHTML.toLowerCase() !== shippingProtectionProduct.replace(/-/g, " ")) {
        if(!product.querySelector('.cart-item__name').innerHTML.includes('Gift Card')) {
          productPrice = Number(product.querySelector('.cart-item__final-price .money').innerHTML.replace(/\$/g, '').replace(/,/g, ''));
          productQuantity = Number(product.querySelector('.cart-item__quantity .quantity__input').getAttribute('value'));
          checkoutSubtotal += productPrice * productQuantity
        }
      }
    }));

    document.querySelectorAll('.cart-item').forEach((product => {
      if(product.getAttribute('data-product-id') == shippingProtectionProductId) {
        shippingProtectionQuantity = product.querySelector('.quantity__input').value;
      }
    }));

    let cartItem = document.querySelectorAll('.cart-item');

    cartItem.forEach((item) => {
      if(item.getAttribute('data-product-id') == shippingProtectionProductId) {
        shippingProtectionInCart = item.getAttribute('data-variant-id');
      }
    });
    
    if(shippingProtectionQuantity > 1) {
      removeDuplicateShippingProtection(shippingProtectionInCart);
    }

    for(let i = 0; i < responseText.variants.length; i++) {
      shippingProtectionCost = responseText.variants[i].title;

      if(checkoutSubtotal <= 50 && shippingProtectionCost === '1.50') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      } else if(checkoutSubtotal <= 100 && shippingProtectionCost === '2.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 150 && shippingProtectionCost === '2.50') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 200 && shippingProtectionCost === '3.50') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 250 && shippingProtectionCost === '4.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 300 && shippingProtectionCost === '4.50') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 350 && shippingProtectionCost === '5.25') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 400 && shippingProtectionCost === '6.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 450 && shippingProtectionCost === '7.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 500 && shippingProtectionCost === '8.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 550 && shippingProtectionCost === '9.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 700 && shippingProtectionCost === '10.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 1000 && shippingProtectionCost === '15.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 1300 && shippingProtectionCost === '25.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 1700 && shippingProtectionCost === '30.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 2000 && shippingProtectionCost === '35.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 2550 && shippingProtectionCost === '40.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 2700 && shippingProtectionCost === '45.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }  else if(checkoutSubtotal <= 3150 && shippingProtectionCost === '50.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      } else if(checkoutSubtotal <= 3600 && shippingProtectionCost === '60.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      } else if(checkoutSubtotal <= 4000 && shippingProtectionCost === '70.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      } else if(checkoutSubtotal >= 4300 && shippingProtectionCost === '80.00') {
        shippingProtectionVariantId = responseText.variants[i].id;
        break;
      }
    }
    return responseText;
    
  }).then((responseText) => {

    const shippingProtectionProductId = responseText.id;
    const cartProtectionVariant = sessionStorage.getItem('le_ship_protection_variant');
    const cartShippingProtectionChecked = document.getElementById('cartShippingProtection').checked;
    let doesShippingProtectionExist = false;
    let shippingProtectionInCart = '';
    let cartItemsCount = 0;
    let multipleShippingProtectionCount = 0;
    let multipleShippingProtectionVariants = [];

    let cartItem = document.querySelectorAll('.cart-item');
    cartItem.forEach((item) => {
      if(item.getAttribute('data-product-id') == shippingProtectionProductId) {
        doesShippingProtectionExist = true;
        shippingProtectionInCart = item.getAttribute('data-variant-id');
      }
    });

    cartItem.forEach((item) => {
      if(item.getAttribute('data-variant-id') !== shippingProtectionInCart) {
        cartItemsCount ++;
      }
    });

    document.querySelectorAll('.cart-item').forEach((product => {
      if(product.getAttribute('data-product-id') == shippingProtectionProductId) {
        multipleShippingProtectionCount ++;
        multipleShippingProtectionVariants.push(product.getAttribute('data-variant-id'))
      }
    }));

    if (cartShippingProtectionChecked == true) {
      if(multipleShippingProtectionCount > 1) {
        removeAndRemoveAndAddProtection(
          multipleShippingProtectionVariants,
          shippingProtectionVariantId
        );
      }
    }

    if(checkoutSubtotal > 0 && cartItemsCount > 0 && cartShippingProtectionChecked == true) {
      if(!doesShippingProtectionExist && cartItemsCount > 0) {
        addShippingProtection(shippingProtectionVariantId);
      } else if (cartProtectionVariant && String(cartProtectionVariant) !== String(shippingProtectionVariantId)) {
        removeAndAddProtection(
          cartProtectionVariant,
          shippingProtectionVariantId
        );
      } else if(shippingProtectionInCart && String(shippingProtectionInCart) !== String(shippingProtectionVariantId)) {
        removeAndAddProtection(
          shippingProtectionInCart,
          shippingProtectionVariantId
        );
      }
    }
    
    if(cartItemsCount <= 0 || cartShippingProtectionChecked == false) {
      if(shippingProtectionInCart) {
        removeShippingProtection(shippingProtectionInCart);
      }
    }

    checkoutSubtotal = 0;
  })
}
